import { Controller } from "@hotwired/stimulus"
import Rails  from "@rails/ujs"

export default class extends Controller {
  connect() {
    this.file = this.element.querySelector("input[type=file]");
    this.file.addEventListener("change", this.onSelectedFilesChanged.bind(this));
    this.selectedFiles = document.getElementById("selected-files");
  }

  selectFiles(e) {
    e.preventDefault();
    this.file.click()
  }

  onSelectedFilesChanged(event) {
    var str = "";
    for (var i = 0; i < this.file.files.length; i++) {
      str += "<li>" + this.file.files[i].name + "</li>";
    }
    this.selectedFiles.innerHTML = str;
  }
}